/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=3b588af4"
import script from "./VForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports